/** @jsxImportSource @emotion/react */
import { useHistory } from 'react-router-dom'
import styled from '@emotion/styled/macro'
import { Button } from '@material-ui/core'
import { SignInHeader, SignInSubtitle } from 'components/partials'
import { pusher } from 'models/api'
import { authButtonWrapperStyles, authWrapperStyles, authButtonStyles } from 'styles'
import { trans, TranslationGroup, TranslationKey } from 'lib/types'
import { clearLocalStorage } from 'models/ThemeMode'

function AccountSuspendedPage() {
  const translation: TranslationGroup = trans.merge(TranslationKey.AUTH)
  const history = useHistory()
  const logout = () => {
    clearLocalStorage()
    pusher?.disconnect()
    history.push('/')
  }
  return (
    <div css={authWrapperStyles}>
      <SignInHeader>Account Suspended</SignInHeader>
      <SignInSubtitle>
        Please contact Client Success at client.success@reactmobile.com to resolve your account and restore access.
      </SignInSubtitle>
      <div css={authButtonWrapperStyles}>
        <Button variant={`contained`} style={authButtonStyles} onClick={logout}>
          {translation.back}
        </Button>
      </div>
    </div>
  )
}

export default AccountSuspendedPage
